/* eslint-disable @angular-eslint/component-class-suffix */
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectChange } from "@angular/material/select";
import { Component, Inject } from "@angular/core";
import { TitleCasePipe } from "@angular/common";
import { VendorAgent } from "common";


@Component({
    selector: 'lib-select-agent-dialog',
    templateUrl: 'select-agent-dialog.html',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, MatButtonModule, TitleCasePipe],
    styles: `
    mat-dialog-content { padding-bottom: 0 !important; }
    mat-form-field { margin-top: 1rem !important; }
    .max-w-300 { max-width: 300px; width: 300px; }
    .adjust-for-mobile {
        @media (max-width: 600px) {
            .max-w-300 { width: 100%; max-width: 250px; }
            padding: 0.5rem;
        }
    }
    `
})
export class SelectVendorAgentDialog {

    public agents: VendorAgent[] = [];

    constructor(
        public dialogRef: MatDialogRef<SelectVendorAgentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { vendorAgents: VendorAgent[] }
    ) {
        if (!data.vendorAgents || data.vendorAgents.length === 0) {
            dialogRef.close(false);
        } else {
            this.agents = data.vendorAgents;
        }
    }

    public onSelectStaff(selection: MatSelectChange): void {
        const agentId = selection.value;
        this.dialogRef.close({ agentId });
    }

}